<template>
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 14V42C4 43.66 5.88 44.6 7.2 43.6L10.62 41.04C11.42 40.44 12.54 40.52 13.26 41.24L16.58 44.58C17.36 45.36 18.64 45.36 19.42 44.58L22.78 41.22C23.48 40.52 24.6 40.44 25.38 41.04L28.8 43.6C30.12 44.58 32 43.64 32 42V8C32 5.8 33.8 4 36 4H14H12C6 4 4 7.58 4 12V14Z" fill="url(#paint0_linear_9007_22524)" />
    <path d="M36.02 4V7C37.34 7 38.6 7.54 39.52 8.44C40.48 9.42 41 10.68 41 12V16.84C41 18.32 40.34 19 38.84 19H35V8.02C35 7.46 35.46 7 36.02 7V4ZM36.02 4C33.8 4 32 5.8 32 8.02V22H38.84C42 22 44 20 44 16.84V12C44 9.8 43.1 7.8 41.66 6.34C40.2 4.9 38.22 4.02 36.02 4C36.04 4 36.02 4 36.02 4Z" fill="url(#paint1_linear_9007_22524)" />
    <defs>
      <linearGradient id="paint0_linear_9007_22524" x1="-1.09343" y1="-30.59" x2="52.3169" y2="-23.0689" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
      <linearGradient id="paint1_linear_9007_22524" x1="30.09" y1="-11.125" x2="50.2224" y2="-8.69368" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
    </defs>
  </svg>
</template>
